import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import login from '@/components/login'
import layout from '@/components/Layout/layout'
import homepage from '@/components/homepage'
import genQrcode from '@/components/genqrcode'
import examination from '@/components/test/examination'
import testMap from '@/components/testMap'
import homepage_docs from '@/components/homepage_docs'
// import testPDF from '@/components/testPDF'

// redirect
import qrcodeRedirect from '@/components/QRcodeRedirect'
// print
import informationGroupqrcode from '@/components/information_print/infor_groupqrcode'
import informationadmin from '@/components/information_print/infor_groupadmin'
import informationuser from '@/components/information_print/infor_user'
import informationaed from '@/components/information_print/infor_aed'
import informationIssue from '@/components/information_print/infor_issue'
import informationRequestHelping from '@/components/information_print/infor_help'
// create
import createAccount from '@/components/create/create_account'
import createAccountMaintenance from '@/components/create/create_accountMaintenance'
// ListReport
import listreportQrcode from '@/components/listReport/Listqrcode'
import listreportAdmin from '@/components/listReport/Listadmin'
import listreportUser from '@/components/listReport/Listuser'
import listreportCompany from '@/components/listReport/Listcompany'
import listreportAed from '@/components/listReport/Listaed'
import listreportIssue from '@/components/listReport/Listissue'
import listrequestHelping from '@/components/listReport/ListrequestHelp'
import listreportIssueAED from '@/components/listReport/ListissueForAED'
import listreportHistory from '@/components/listReport/Listhistory'
import listreportHistoryuse from '@/components/listReport/ListhistoryUse'
Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    { path: '/homepage_docs', component: homepage_docs },
    { path: '/testMap', component: testMap },
    { path: '/examination' , component: examination},
    {
      path: '/login',
      component: login
    },
    {
      path: '/AEDQRcode/:id', component: qrcodeRedirect
    },
    {
      path: '/layout',
      component: layout,
      children: [
        { path: '/', component: homepage },
        // { path: '/testMap', component: testMap },
        { path: '/homepage', component: homepage },
        { path: '/genQrcode', component: genQrcode },
        { path: '/create_account', component: createAccount },
        { path: '/create_maintenance', component: createAccountMaintenance },
        { path: '/information/admin', component: listreportAdmin },
        { path: '/information_admin', component: informationadmin },
        { path: '/information/user', component: listreportUser },
        { path: '/information_user', component: informationuser },
        { path: '/information/aed', component: listreportAed },
        { path: '/information_aed', component: informationaed },
        { path: '/information/qrcode', component: listreportQrcode },
        { path: '/information_qrcode', component: informationGroupqrcode},
        { path: '/information/requestHelping', component: listrequestHelping },
        { path: '/information_requestHelping', component: informationRequestHelping },
        { path: '/information/issue', component: listreportIssue },
        { path: '/information/issueAED', component: listreportIssueAED},
        { path: '/information_issue', component: informationIssue},
        { path: '/information/company', component: listreportCompany},
        { path: '/information/history_use', component: listreportHistoryuse},
        { path: '/information/historyAED', component: listreportHistory}
      ]
    },
    { path: '*', redirect: '/login' }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js